import ContentModal from './ContentModal';
export * from './ContentModal';
export default ContentModal;